import PropTypes from "prop-types";
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { Skeleton, Spin } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import WidgetCard from "../widget/card";
import BoxListingEventRow from "./boxListingEventRow";
import "./style.css";

const BoxListing = ({
  showOtherElementsCustomAction,  
  title,
  boxWrapClass,
  elements, isCentered,
  isGettingLastEInvoices,
  isGettingObjectiveDeadlines,
  numElementsDisplayed,
  showLoading,
  getWorkspaceId }) => {
  const intl = useIntl();
  
  const renderTitle = items => {
    const notEmptyInvoices = items && items?.length > 0;
    return (
      <div
        key="dbx-boxListing-widgetTitle"
        style={{
          width: "100%",
          display: "inline-block",
          marginTop: 13,
          borderBottom: notEmptyInvoices ? "none" : "1px solid #f2f5f8",
          paddingBottom: notEmptyInvoices ? "initial" : 8
        }}
      >
        {title}
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div style={{ textAlign: "right" }}>
        <Button
          kind={"secondary"}
          colorScheme={"ghost"}
          onClick={e => {
            if (showOtherElementsCustomAction) {
              showOtherElementsCustomAction();
            }
          }}
        >
          {" "}
          Guarda tutte{" "}
        </Button>
      </div>
    );
  };

  const elementsToShow = elements?.slice(0, numElementsDisplayed);
  const items = elementsToShow?.map((x, index) => {
    return (
      <BoxListingEventRow
        getWorkspaceId={getWorkspaceId}
        invoiceId={x.invoiceId}
        date={x.data}
        lines={x.lines}
        key={"boxListing_" + index}
        truncate={true}      
      />
    );
  });
  /** TODO mettere classe bigBox a cardBox */
  return (
    <WidgetCard
      type={"box1_3"}
      titleWidget={renderTitle(items)}
      footer={items && items?.length > 0 && renderFooter()}
      isCentered={(isCentered && items?.length > 0) || isCentered == null}
    >
      <div>
        <Spin
          indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
          tip={intl.formatMessage({id: "notification.loading"})}
          spinning={!!showLoading}
          wrapperClassName={`spin-${boxWrapClass}`}
        >
          <div className={"cardBox_container"}>
            <div className={"cardBoxItemsList"}>
              {items?.length > 0 ? (
                items
              ) : isGettingObjectiveDeadlines || isGettingLastEInvoices ? (
                <div style={{ textAlign: "center" }}>
                  <FontAwesomeIcon
                    icon={["far", "circle-notch"]}
                    spin
                    style={{
                      fontSize: "40px",
                      color: "#1890ff"
                    }}
                  />{" "}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    paddingLeft: 8,
                    flexWrap: "wrap"
                  }}
                >
                  <FontAwesomeIcon
                    icon={["far", "info-circle"]}
                    style={{ color: "#c9d9e8", fontSize: 32, margin: 8 }}
                  />
                  <div>
                    <div
                      style={{
                        color: "#005075",
                        fontSize: 16,
                        fontFamily: "Cairo",
                        fontWeight: 600
                      }}
                    >
                      <FormattedMessage id="dashboard.noInvoices1" />
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#152935",
                        fontWeight: 100
                      }}
                    >
                      <FormattedMessage id="dashboard.noInvoices2" />
                    </div>
                  </div>
                  <div
                    className="empty-box-listing-widget"
                    style={{ padding: "16px 32px 0px 8px", width: "100%" }}
                  >
                    <Skeleton
                      paragraph={{ rows: 6, width: "100%" }}
                      title={false}
                      round={true}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Spin>
      </div>
    </WidgetCard>
  );
};

BoxListing.propTypes = {
  boxWrapClass: PropTypes.string,
  elements: PropTypes.array,
  emptyMessage: PropTypes.string,
  isCentered: PropTypes.bool,
  isGettingObjectiveDeadlines: PropTypes.bool,
  isGettingLastEInvoices: PropTypes.bool,  
  numElementsDisplayed: PropTypes.number,
  showLoading: PropTypes.bool,
  showOtherElementsCustomAction: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default BoxListing;